import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';
import { FormRenderProps } from 'react-final-form';

import { AppState } from 'services/types';
import {
    requestManageTimesheetTimesheetEntries,
    canceledManageTimesheetTimesheetEntries
    // @ts-ignore
} from 'services/timesheetTimesheetEntries/actions';
import {
    setFinalFormUnsavedValues,
    removeFinalFormUnsavedValues
    // @ts-ignore
} from 'services/finalFormsUnsavedValues/actions';
// @ts-ignore
import { selectIsOnline } from 'services/connection/selectors';
// @ts-ignore
import { formatEntryForSubmit } from 'utils/timesheets';

interface OwnProps {
    namespace: string;
    formProps: FormRenderProps;
}

interface ConnectedProps {
    isOnline: ReturnType<typeof selectIsOnline>;
}

interface DispatchProps {
    requestManageTimesheetTimesheetEntries: typeof requestManageTimesheetTimesheetEntries;
    canceledManageTimesheetTimesheetEntries: typeof canceledManageTimesheetTimesheetEntries;
    setFinalFormUnsavedValues: typeof setFinalFormUnsavedValues;
    removeFinalFormUnsavedValues: typeof removeFinalFormUnsavedValues;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class TimesheetTimesheetEntriesFormAutoSave extends React.Component<
    Props
> {
    componentDidMount(): void {
        this.handleSave();
    }

    componentDidUpdate(prevProps: Props): void {
        const { formProps, isOnline, namespace, ...props } = this.props;

        if (
            !isEqual(prevProps.formProps.values, formProps.values) ||
            (!prevProps.isOnline && isOnline)
        ) {
            this.handleSave();
        }

        if (isEqual(formProps.initialValues, formProps.values)) {
            props.removeFinalFormUnsavedValues(namespace);
        }
    }

    handleSave = (): void => {
        const { namespace, isOnline } = this.props;
        const {
            formProps: { initialValues, values, valid }
        } = this.props;
        const initialValuesKeys = Object.keys(initialValues);
        const valuesKeys = Object.keys(values);

        const createdValuesKeys = valuesKeys.filter(
            key => !initialValuesKeys.includes(key)
        );
        const deletedValuesKeys = initialValuesKeys.filter(
            key => !valuesKeys.includes(key)
        );
        const otherValuesKeys = valuesKeys.filter(key =>
            initialValuesKeys.includes(key)
        );
        const updatedValuesKeys = otherValuesKeys.filter(
            // @ts-ignore
            key => !isEqual(initialValues[key], values[key])
        );

        const hasCreates = createdValuesKeys.length;
        const hasUpdates = updatedValuesKeys.length;
        const hasDeletes = deletedValuesKeys.length;

        if (hasCreates || hasUpdates || hasDeletes) {
            const create = createdValuesKeys.map((key: string) => {
                // @ts-ignore
                const value = values[key];
                return value;
            });

            const update = updatedValuesKeys.map((key: string) => {
                // @ts-ignore
                const value = values[key];
                return value;
            });

            const diff = {
                create,
                update,
                delete: deletedValuesKeys
            };

            if (valid && isOnline) {
                this.props.requestManageTimesheetTimesheetEntries({
                    create: diff.create.map(value =>
                        formatEntryForSubmit(value)
                    ),
                    update: diff.update.map(value =>
                        formatEntryForSubmit(value, {
                            excludeTimesheetId: true
                        })
                    ),
                    delete: diff.delete
                });
            }

            this.props.setFinalFormUnsavedValues(namespace, diff);
        }

        if (!valid || !isOnline) {
            this.props.canceledManageTimesheetTimesheetEntries();
        }
    };

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isOnline: selectIsOnline
});

export default connect(mapStateToProps, {
    requestManageTimesheetTimesheetEntries,
    canceledManageTimesheetTimesheetEntries,
    setFinalFormUnsavedValues,
    removeFinalFormUnsavedValues
})(TimesheetTimesheetEntriesFormAutoSave);
